<script setup>
import { parseHeziyunData } from '@/utils/heziyunData' // 解析数据

import axios from 'axios'
import { Message } from '@arco-design/web-vue';
// 引入 Swiper
import Swiper from 'swiper'
import { Grid, Pagination, Navigation } from 'swiper/modules'
import 'swiper/swiper-bundle.css'


const HeziyunData = ref(parseHeziyunData().global)

console.log(HeziyunData.value)

// 注册 Swiper 模块
Swiper.use([Grid, Pagination, Navigation])

// 响应式数据
const jwt = ref(localStorage.getItem('jwt') || null)
const defaultConfig = ref({})
const domainSuffixList = ref([])
const domain = ref({ suffix: '' })
const domainIndex = ref(0)
const enterFieldName = ref('')
const isExpand = ref(false)
const swiperInstance = ref(null)

// 产品价格数据
const domains = ref([
    { suffix: "com", description: "全球最受欢迎的通用顶级域名，适用于商业网站", price: 68, originalPrice: 78, popular: true, new: false },
    { suffix: "cn", description: "中国国家顶级域名，本土化标识", price: 28, originalPrice: 35, popular: true, new: false },
    { suffix: "net", description: "网络服务商和科技公司首选", price: 72, originalPrice: 82, popular: true, new: false },
    { suffix: "shop", description: "电子商务和在线商店专用", price: 45, originalPrice: 60, popular: false, new: true },
    { suffix: "top", description: "高端品牌和优质服务", price: 38, originalPrice: 48, popular: false, new: true },
    { suffix: "art", description: "艺术和创意作品", price: 75, originalPrice: 90, popular: false, new: true },
    { suffix: "vip", description: "高端会员服务和尊贵体验", price: 150, originalPrice: 180, popular: false, new: true },
    { suffix: "cloud", description: "云计算和云服务", price: 280, originalPrice: 350, popular: false, new: true },
    { suffix: "中国", description: "中文国家顶级域名", price: 120, originalPrice: 150, popular: false, new: false },
    { suffix: "org", description: "非营利组织和公益机构专用", price: 85, originalPrice: 0, popular: false, new: false },
    { suffix: "io", description: "科技创业公司和开发者青睐", price: 320, originalPrice: 380, popular: true, new: false },
    { suffix: "co", description: "公司的简短替代域名", price: 180, originalPrice: 220, popular: false, new: false },
    { suffix: "ai", description: "人工智能和科技公司专用", price: 580, originalPrice: 650, popular: false, new: true },
    { suffix: "app", description: "移动应用程序专用域名", price: 120, originalPrice: 150, popular: false, new: true },
    { suffix: "site", description: "适用于各类网站", price: 35, originalPrice: 50, popular: false, new: false },
    { suffix: "online", description: "在线业务和服务的理想选择", price: 40, originalPrice: 55, popular: false, new: false },
    { suffix: "xyz", description: "新一代创意域名", price: 25, originalPrice: 35, popular: false, new: false },
    { suffix: "info", description: "信息类网站专用", price: 65, originalPrice: 75, popular: false, new: false },
    { suffix: "biz", description: "商业网站的替代选择", price: 75, originalPrice: 85, popular: false, new: false },
    { suffix: "me", description: "个人品牌和简历网站", price: 95, originalPrice: 110, popular: false, new: false },
    { suffix: "cc", description: "创意社区和公司", price: 55, originalPrice: 70, popular: false, new: false },
    { suffix: "fun", description: "娱乐和休闲网站", price: 65, originalPrice: 80, popular: false, new: true },
])

// 模拟数据（实际应该从父组件传入）
const data = ref({
    footer: {
        webname: '您的网站名称'
    }
})

// 生命周期
onMounted(() => {
    // 获取默认配置
    getDefaultConfig()
    // 获取域名后缀列表
    getDomainSuffixList()
    // 初始化 Swiper
    swiperInit()
})

onUnmounted(() => {
    if (swiperInstance.value) {
        swiperInstance.value.destroy()
    }
})

// 方法
const getDefaultConfig = async () => {
    try {
        const res = await axios.get('/console/v1/idcsmart_domain/config', {
            headers: { Authorization: `Bearer ${jwt.value}` }
        })

        if (res.status === 200) {
            defaultConfig.value = res.data.data
        }
    } catch (error) {
        showNotification('当前网站域名注册模板未开启,请在开启后进入页面.', 'danger')
    }
}

const getDomainSuffixList = async () => {
    try {
        const res = await axios.get('/console/v1/idcsmart_domain/domain_suffix', {
            headers: { Authorization: `Bearer ${jwt.value}` }
        })

        if (res.status === 200) {
            domainSuffixList.value = res.data.data
            if (domainSuffixList.value.length > 0) {
                domain.value = domainSuffixList.value[0]
            } else {
                domain.value = { suffix: '未添加后缀' }
            }
        }
    } catch (error) {
        showNotification('当前网站域名注册模板未开启,请在开启后进入页面.', 'danger')
    }
}

// 切换域名后缀
const switchSuffix = (item, index) => {
    domain.value = item
    domainIndex.value = index
    isExpand.value = false
}

// 查询按钮
const query = (name = data.value.footer.webname) => {
    if (domain.value.suffix === '未添加后缀') {
        showNotification(`${name}当前提醒您! 未添加后缀名 - 请联系站长添加后缀名.`, 'danger')
        return
    }

    if (!enterFieldName.value.trim()) {
        showNotification(`${name}当前提醒您! 请在输入框填写域名,否则将无法查询.`, 'danger')
        return
    }

    window.open(`${defaultConfig.value.domain_url}&domain=${enterFieldName.value}&suffix=${domain.value.suffix}`)
}

// swiper初始化
const swiperInit = () => {
    nextTick(() => {
        swiperInstance.value = new Swiper('.mySwiper', {
            modules: [Grid, Pagination, Navigation],
            slidesPerView: 4,
            grid: {
                rows: 2,
            },
            spaceBetween: 30,
            // 禁止自动切换
            autoplay: false,
            // 分页器配置
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            // 添加导航按钮
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            // 响应式配置
            breakpoints: {
                320: {
                    slidesPerView: 1,
                    grid: {
                        rows: 1,
                    }
                },
                768: {
                    slidesPerView: 2,
                    grid: {
                        rows: 2,
                    }
                },
                1024: {
                    slidesPerView: 3,
                    grid: {
                        rows: 2,
                    }
                },
                1200: {
                    slidesPerView: 4,
                    grid: {
                        rows: 2,
                    }
                }
            }
        })
    })
}

const redirectPage = () => {
    window.open(`${defaultConfig.value.domain_url}`)
}

// 修改后（使用 Arco Design 的 Message 组件）
const showNotification = (message, type = 'info') => {
    const typeMap = {
        info: 'info',
        success: 'success',
        warning: 'warning',
        error: 'error',
        danger: 'error' // 将 danger 映射为 error 类型
    }

    Message[typeMap[type] || 'info']({
        content: message,
        duration: 3000
    })
}
</script>

<template>

    <!-- banner图 -->
    <div class="Heziyun-banners">
        <div class="Heziyun-defaultWidth">
            <div class="Heziyun-banner-title">
                <span>{{ HeziyunData?.webname }} · 域名注册与管理一站服务</span>
                <p>百余款域名后缀随心选，新用户注册COM域名仅需33元！</p>
            </div>

            <!-- 域名搜索 -->
            <div class="Heziyun-domainSearch">
                <div class="Heziyun-search">
                    <input type="text" placeholder="请输入您要注册的域名" v-model="enterFieldName"
                        @keyup.enter="query(data.footer.webname)">
                    <div class="Heziyun-itemSelect" @click="isExpand = !isExpand">
                        <span>{{ domain.suffix }}</span>
                        <svg viewBox="0 0 1537 1024" width="8" height="8">
                            <path
                                d="M1535.2 86.7c0 17 0 34.1-17 51.1L836.6 955.8c-17 17-34 34-68 34s-51-17-68-34L18.6 137.9C-15.5 103.8 1.5 52.7 35.6 18.6c34-34 85-17 119 17l613.5 732.8L1381.9 35.6c34-34 85-34 119-17 17 17 34 34 34 68.1z"
                                fill="currentColor" />
                        </svg>
                    </div>
                    <button @click="query(data.footer.webname)">域名查询</button>
                </div>
                <!-- 域名后缀选择 -->
                <transition name="suffix">
                    <div class="Heziyun-suffix" v-if="isExpand">
                        <div class="Heziyun-listWithin">
                            <div class="Heziyun-item" v-for="(item, index) in domainSuffixList" :key="index"
                                @click="switchSuffix(item, index)" :class="{ 'Heziyun-active': domainIndex === index }">
                                {{ item.suffix }}
                            </div>
                        </div>
                    </div>
                </transition>
            </div>
        </div>
    </div>

    <!-- 产品价格 -->
    <div class="Heziyun-productPrice Heziyun-padding">
        <div class="Heziyun-defaultWidth">
            <div class="Heziyun-commodity-title">
                <span>域名注册价格</span>
                <p>多规格实例组合，轻松应对不同应用场景的个性化算力诉求</p>
            </div>

            <!-- 域名搜索 -->
            <div class="Heziyun-domainSearch">
                <div class="swiper mySwiper">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="(item, index) in domains" :key="index">
                            <div class="Heziyun-recommend" v-if="item.popular">推</div>
                            <div class="Heziyun-title">.{{ item.suffix }}</div>
                            <p>{{ item.description }}</p>
                            <div class="Heziyun-price">
                                <div class="Heziyun-yuanPrice">
                                    ￥{{ item.price }}
                                    <em>/首年</em>
                                </div>
                                <span v-if="item.originalPrice" class="original-price">
                                    ￥{{ item.originalPrice }}
                                    <em>/首年</em>
                                </span>
                            </div>
                            <button @click="redirectPage">立即注册</button>
                        </div>
                    </div>
                    <!-- 分页器 -->
                    <div class="swiper-pagination"></div>
                    <!-- 导航按钮 -->
                    <div class="swiper-button-next"></div>
                    <div class="swiper-button-prev"></div>
                </div>
            </div>
        </div>
    </div>

</template>

<style>
@import "@/static/css/import";
@import "@/static/font/font.css";

body {
    background-color: #f5f7fc;
}

.swiper-navigation-icon {
    width: 35% !important;
}


.swiper-pagination-bullet {
    width: 25px;
    height: 4px;
    border-radius: 0px;
}
</style>

<style lang="less" scoped>
// banner图
.Heziyun-banners {
    background: url("../../static/img/domain/banner.png") no-repeat center;
    background-size: 100% 100%;
    position: relative;
    margin-top: 3.6rem;
    padding: 0;
    height: 25rem;

    .Heziyun-defaultWidth {
        position: relative;
        z-index: 2;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 2rem;

        .Heziyun-banner-title {
            align-items: center;
            height: auto;
            gap: 0.5rem;

            span {
                color: #222;
                font-size: 36px;
            }

            p {
                text-align: center;
                color: #222;
            }

        }

        // 域名搜索
        .Heziyun-domainSearch {
            position: relative;

            .Heziyun-search {
                display: flex;
                align-items: center;
                background-color: #fff;
                height: 2.8rem;
                border-radius: 5px;
                -webkit-border-radius: 5px;
                -moz-border-radius: 5px;
                -ms-border-radius: 5px;
                -o-border-radius: 5px;
                overflow: hidden;
                border: 1px solid transparent;

                &:hover {
                    border-color: rgb(36, 104, 242);
                }

                &:focus {
                    border-color: rgb(36, 104, 242);
                }

                input {
                    width: 30rem;
                    height: 100%;
                    padding: 0 0.5rem 0 1rem;
                    border-radius: 5px 0 0 5px;
                    -webkit-border-radius: 5px 0 0 5px;
                    -moz-border-radius: 5px 0 0 5px;
                    -ms-border-radius: 5px 0 0 5px;
                    -o-border-radius: 5px 0 0 5px;
                }

                .Heziyun-itemSelect {
                    width: 6rem;
                    height: 100%;
                    position: relative;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 0.3rem;

                    span {
                        color: #222;
                    }

                    svg {
                        width: 0.5rem;
                        height: 0.5rem;
                        margin-top: 0.2rem;
                    }

                    &::before {
                        content: '';
                        position: absolute;
                        left: 0rem;
                        top: 50%;
                        transform: translateY(-50%);
                        width: 1px;
                        height: 40%;
                        background-color: #999;
                    }
                }

                button {
                    background-color: rgb(36, 104, 242);
                    height: 100%;
                    color: #fff;
                    width: 8rem;
                    font-size: 0.8rem;

                    &:hover {
                        background-color: rgb(88 139 242);
                    }
                }
            }

            /* 进入前和离开后的状态 */
            .suffix-enter,
            .suffix-leave-to {
                max-height: 0 !important;
            }

            /* 进入后和离开前的状态 */
            .suffix-enter-to,
            .suffix-leave {
                max-height: 260px;
            }

            /* 进入和离开的激活状态 */
            .suffix-enter-active,
            .suffix-leave-active {
                transition: all 0.5s ease;
                -webkit-transition: all 0.5s ease;
                -moz-transition: all 0.5s ease;
                -ms-transition: all 0.5s ease;
                -o-transition: all 0.5s ease;
            }

            // 域名后缀选择
            .Heziyun-suffix {
                position: absolute;
                top: 2.9rem;
                left: 0;
                width: calc(100% - 8rem);
                background-color: #fff;
                border-radius: 5px;
                -webkit-border-radius: 5px;
                -moz-border-radius: 5px;
                -ms-border-radius: 5px;
                -o-border-radius: 5px;
                max-height: 260px;
                transition: all 0.5s ease;
                -webkit-transition: all 0.5s ease;
                -moz-transition: all 0.5s ease;
                -ms-transition: all 0.5s ease;
                -o-transition: all 0.5s ease;
                overflow: hidden;

                .Heziyun-listWithin {
                    padding: 1rem;
                    display: grid;
                    grid-template-columns: repeat(auto-fill, minmax(4.5rem, 1fr));
                    gap: 0.6rem;
                    overflow-y: scroll;
                    max-height: 260px;

                    /* 滚动条整体样式 */
                    &::-webkit-scrollbar {
                        width: 8px;
                        height: 8px;
                        background-color: transparent;
                    }

                    /* 滚动条轨道样式 */
                    &::-webkit-scrollbar-track {
                        background-color: #fff;
                    }

                    /* 滚动条滑块样式 */
                    &::-webkit-scrollbar-thumb {
                        background-color: rgb(204, 204, 204);
                        border-radius: 3px;
                    }

                    /* 滚动条滑块悬停样式 */
                    &::-webkit-scrollbar-thumb:hover {
                        background-color: rgb(170, 170, 170);
                    }

                    .Heziyun-item {
                        background-color: #f1f2f5;
                        padding: 0.2rem;
                        text-align: center;
                        border-radius: 2px;
                        cursor: pointer;
                        border: 1px solid transparent;

                        &:hover {
                            background-color: #e3e6eb;
                        }

                        &.Heziyun-active {
                            border-color: #005eff;
                            background-color: #e6f3ff;
                        }
                    }
                }
            }
        }
    }

}

.swiper-grid-column>.swiper-wrapper {
    flex-direction: initial !important;
    gap: 30px 0;
    padding: 30px 0;
}

.swiper-slide {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
}


@font-face {
    font-family: "DINProM";
    src: url('../../static/font/file/DINPro-Medium.woff');
}

// 产品价格
.Heziyun-productPrice {
    .Heziyun-defaultWidth {
        .Heziyun-domainSearch {
            .swiper {
                padding-bottom: 1rem;

                &:hover {


                    .swiper-button-prev {
                        left: 1%;
                    }

                    .swiper-button-next {
                        right: 1%;
                        transition: all 0.3s ease;
                    }
                }

                .swiper-wrapper {
                    .swiper-slide {
                        border: 1px solid #e1e6f0;
                        height: 214px;
                        padding: 20px;
                        transition: all 0.3s;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        gap: 1rem;
                        position: relative;

                        &:hover {
                            transform: translateY(-10px);
                            -webkit-transform: translateY(-10px);
                            -moz-transform: translateY(-10px);
                            -ms-transform: translateY(-10px);
                            -o-transform: translateY(-10px);
                            box-shadow: 2px 10px 20px 5px rgba(5, 17, 71, 0.07);
                            transition: all 0.3s;

                            button {
                                opacity: 1;
                            }
                        }

                        .Heziyun-recommend {
                            background: url('../../static/img/domain/hotSeller2.png') no-repeat center;
                            background-size: cover;
                            width: 2.5rem;
                            height: 2.5rem;
                            position: absolute;
                            top: -0.5rem;
                            right: 2rem;
                            font-size: 16px;
                            color: #fff;
                            font-family: PingFangSC-Medium, PingFangSC, PingFang SC;
                            line-height: 2.2;
                            text-align: center;
                        }

                        .Heziyun-title {
                            font-size: 38px;
                            color: #040F43;
                            font-family: "DINProM";
                        }

                        p {
                            height: 3rem;
                            line-height: 1.7;
                        }

                        .Heziyun-price {
                            color: #E8001C;
                            font-size: 30px;
                            line-height: 30px;
                            font-weight: 400;
                            font-family: "DINProM";
                            display: flex;
                            align-items: flex-end;
                            justify-content: space-between;

                            em {
                                font-size: 14px;
                                font-style: normal;
                            }

                            span {
                                font-size: 14px;
                                color: #8187A1;
                                text-decoration: line-through;

                                em {
                                    font-size: 12px;
                                }
                            }
                        }

                        button {
                            position: absolute;
                            bottom: 20px;
                            left: 50%;
                            transform: translateX(-50%);
                            background-color: #0056ff;
                            color: #fff;
                            width: calc(100% - 40px);
                            opacity: 0;
                            height: 40px;
                            font-size: 14.5px;
                            transition: none;
                            -webkit-transition: none;
                            -moz-transition: none;
                            -ms-transition: none;
                            -o-transition: none;

                            &:hover {
                                background-color: #4080ff;
                            }
                        }
                    }
                }

                .swiper-button-next,
                .swiper-button-prev {
                    width: 35px;
                    height: 60px;
                    color: #fff;
                    font-size: 13px;
                    background-color: #3464ff;
                    opacity: .4;
                    border-radius: 3px;
                    cursor: pointer;

                    &:hover {
                        opacity: .8;
                    }
                }

                .swiper-button-next {
                    right: -6%;
                }

                .swiper-button-prev {
                    left: -6%;
                }


                .swiper-button-next:after,
                .swiper-button-prev:after {
                    font-size: 20px;
                    font-weight: 600;
                }
            }
        }
    }
}

@media (max-width: 768px) {

    // banner图
    .Heziyun-banners {
        margin-top: 15vw;
        padding: 0;
        height: 70vw;

        .Heziyun-defaultWidth {
            gap: 4vw;

            .Heziyun-banner-title {
                gap: 3vw;

                span {
                    color: #222;
                    font-size: 5vw;
                }

            }

            // 域名搜索
            .Heziyun-domainSearch {
                width: 100%;

                .Heziyun-search {
                    display: flex;
                    align-items: center;
                    background-color: #fff;
                    height: 9vw;
                    border-radius: 1px;
                    -webkit-border-radius: 1px;
                    -moz-border-radius: 1px;
                    -ms-border-radius: 1px;
                    -o-border-radius: 1px;

                    input {
                        width: 70%;
                        height: 100%;
                        padding: 0 0 0 3vw;
                    }

                    .Heziyun-itemSelect {
                        width: 30%;
                        gap: 2vw;

                        svg {
                            width: 2vw;
                            height: 2vw;
                            margin-top: 1vw;

                        }
                    }

                    button {
                        width: 25vw;
                        font-size: 3.5vw;
                    }
                }

                /* 进入后和离开前的状态 */
                .suffix-enter-to,
                .suffix-leave {
                    max-height: 260px;
                }

                // 域名后缀选择
                .Heziyun-suffix {
                    position: absolute;
                    top: 9vw;
                    left: 0;
                    width: calc(100%);
                    background-color: #fff;
                    border-radius: 2px;
                    -webkit-border-radius: 2px;
                    -moz-border-radius: 2px;
                    -ms-border-radius: 2px;
                    -o-border-radius: 2px;
                    max-height: 260px;
                    transition: all 0.5s ease;
                    -webkit-transition: all 0.5s ease;
                    -moz-transition: all 0.5s ease;
                    -ms-transition: all 0.5s ease;
                    -o-transition: all 0.5s ease;
                    overflow: hidden;

                    .Heziyun-listWithin {
                        padding: 2vw;
                        grid-template-columns: repeat(auto-fill, minmax(15vw, 1fr));
                        gap: 2vw;
                        max-height: 260px;

                        .Heziyun-item {
                            padding: 1vw;
                        }
                    }
                }
            }
        }

    }

    // 产品价格
    .Heziyun-productPrice {
        .Heziyun-defaultWidth {
            .Heziyun-domainSearch {
                .swiper {
                    padding-bottom: 25vw;

                    .swiper-wrapper {
                        .swiper-slide {
                            height: 214px;
                            padding: 5vw;
                            gap: 3vw;
                            overflow: initial;

                            &:hover {
                                transform: translateY(0);
                            }

                            .Heziyun-recommend {
                                width: 10vw;
                                height: 10vw;
                                top: -1vw;
                                right: 4vw;
                                font-size: 3.5vw;

                            }

                            .Heziyun-title {
                                font-size: 38px;
                                color: #040F43;
                                font-family: "DINProM";
                            }

                            p {
                                height: 3rem;
                                line-height: 1.7;
                            }

                            .Heziyun-price {
                                color: #E8001C;
                                font-size: 30px;
                                line-height: 30px;
                                font-weight: 400;
                                font-family: "DINProM";
                                display: flex;
                                align-items: flex-end;
                                justify-content: space-between;

                                em {
                                    font-size: 14px;
                                    font-style: normal;
                                }

                                span {
                                    font-size: 14px;
                                    color: #8187A1;
                                    text-decoration: line-through;

                                    em {
                                        font-size: 12px;
                                    }
                                }
                            }

                            button {
                                position: absolute;
                                bottom: 20px;
                                left: 50%;
                                transform: translateX(-50%);
                                background-color: #0056ff;
                                color: #fff;
                                width: calc(100% - 40px);
                                opacity: 0;
                                height: 40px;
                                font-size: 14.5px;
                                transition: none;
                                -webkit-transition: none;
                                -moz-transition: none;
                                -ms-transition: none;
                                -o-transition: none;

                                &:hover {
                                    background-color: #4080ff;
                                }
                            }
                        }
                    }

                    .swiper-button-next,
                    .swiper-button-prev {
                        width: 35px;
                        height: 60px;
                        color: #fff;
                        font-size: 13px;
                        background-color: #3464ff;
                        opacity: .4;
                        border-radius: 3px;
                        cursor: pointer;

                        &:hover {
                            opacity: .8;
                        }
                    }

                    .swiper-button-next {
                        right: 1%;
                        width: 20px;
                        height: 40px;
                    }

                    .swiper-button-prev {
                        left: 1%;
                        width: 20px;
                        height: 40px;
                    }

                    .swiper-button-prev,
                    .swiper-button-next {
                        transform: translateY(-50%);
                    }

                    .swiper-button-next:after,
                    .swiper-button-prev:after {
                        font-size: 20px;
                        font-weight: 600;
                    }
                }
            }
        }
    }
}
</style>